"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.isDarkTheme = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var polished_1 = require("polished");
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var cssProperties_1 = require("../cssProperties");
var Context_1 = require("./Context");
var prepareTheme_1 = require("./prepareTheme");
/**
 * @internal
 */
exports.isDarkTheme = function (theme) {
    var _a, _b, _c, _d;
    var firstColor = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) === null || _b === void 0 ? void 0 : _b.c0;
    var lastColor = (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) === null || _d === void 0 ? void 0 : _d.c9;
    if (!firstColor || !lastColor) {
        return false;
    }
    return polished_1.getLuminance(firstColor) < polished_1.getLuminance(lastColor);
};
/**
 * Fetches the theme object from the backend upon mounting and passes both theme object and isThemeLoading flag
 * to the context via ThemeContextProvider
 *
 * Converts properties from theme object into CSS variables and injects them into <body> via setCssProperties
 *
 * Both backend and workspace can be passed as an arguments, otherwise the component tries to get these from the context
 *
 * @public
 */
exports.ThemeProvider = function (_a) {
    var children = _a.children, themeParam = _a.theme, backendParam = _a.backend, workspaceParam = _a.workspace, _b = _a.modifier, modifier = _b === void 0 ? identity_1.default : _b, _c = _a.enableComplementaryPalette, enableComplementaryPalette = _c === void 0 ? true : _c;
    var backend = sdk_ui_1.useBackend(backendParam);
    var workspace = sdk_ui_1.useWorkspace(workspaceParam);
    var _d = react_1.useState(themeParam !== null && themeParam !== void 0 ? themeParam : {}), theme = _d[0], setTheme = _d[1];
    var _e = react_1.useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var lastWorkspace = react_1.useRef();
    lastWorkspace.current = workspace;
    react_1.useEffect(function () {
        cssProperties_1.clearCssProperties();
        // no need to load anything if the themeParam is present
        if (themeParam) {
            var preparedTheme = prepareTheme_1.prepareTheme(themeParam, enableComplementaryPalette);
            setTheme(preparedTheme);
            cssProperties_1.setCssProperties(preparedTheme, exports.isDarkTheme(preparedTheme));
            return;
        }
        var fetchData = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var selectedTheme, modifiedTheme, preparedTheme;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!backend || !workspace) {
                            return [2 /*return*/];
                        }
                        setIsLoading(true);
                        return [4 /*yield*/, backend.workspace(workspace).styling().getTheme()];
                    case 1:
                        selectedTheme = _a.sent();
                        if (lastWorkspace.current === workspace) {
                            modifiedTheme = modifier(selectedTheme);
                            preparedTheme = prepareTheme_1.prepareTheme(modifiedTheme, enableComplementaryPalette);
                            setTheme(preparedTheme);
                            setIsLoading(false);
                            cssProperties_1.setCssProperties(preparedTheme, exports.isDarkTheme(preparedTheme));
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchData();
    }, [themeParam, workspace, backend]);
    react_1.useEffect(function () {
        return function () {
            cssProperties_1.clearCssProperties();
        };
    }, []);
    return (react_1.default.createElement(Context_1.ThemeContextProvider, { theme: theme, themeIsLoading: isLoading }, children));
};
//# sourceMappingURL=ThemeProvider.js.map